import React, { Component, Fragment } from 'react';

// @atlaskit
import { colors } from '@atlaskit/theme';
import CreateIcon from '@atlaskit/icon/glyph/add';
import Nav, { AkContainerLogo, AkContainerNavigationNested, presetThemes } from '@atlaskit/navigation';
import SearchIcon from '@atlaskit/icon/glyph/search';
import Tooltip from '@atlaskit/tooltip';

// @source
// import HelpDropdownMenu from './HelpDropdownMenu';
import { account as constant } from '../../../constants';
import { PrimaryIcon } from './Similar';
import { RBSReportWordmark } from '../../media';
import { User } from '../../../tools';
import AccountDropdownMenu from './AccountDropdownMenu';
import CreateDrawer from './CreateDrawer';
import FeedbackColector from '../FeedbackColector';
import SearchDrawer from './SearchDrawer';
import Stack from './Stack';
// import WsConnect from '../Chat/WsConnect';

const containerHeaderComponent = () => (
  <AkContainerLogo>
    <div style={{ padding: '6.5px 0' }}>
      <RBSReportWordmark width={90} style={{ fill: colors.B50 }} />
    </div>
  </AkContainerLogo>
);

const initialState = {
  feedback: false,
  isOpen: true,
  openDrawer: null,
  width: 304,
};

const enums = {
  search: 'search',
  create: 'create',
};

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.account = User.getUserInfo();
    this.state = initialState;
    this.onResize = this.onResize.bind(this);
    this.onToggleFeedback = this.onToggleFeedback.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
  }

  onResize({ isOpen, width }) {
    this.setState({ isOpen, width });
  }

  onToggleFeedback() {
    this.setState({ feedback: !this.state.feedback });
  }

  openDrawer(openDrawer) {
    this.setState({ openDrawer });
  }

  render() {
    const isMobile = window.outerWidth < 768;

    if (isMobile) {
      this.account.Type = constant.USER;
    }

    const props = this.account.Type !== constant.USER ? {
      globalSearchIcon: (
        <Tooltip content="Search" position="right">
          <SearchIcon label="Search icon" />
        </Tooltip>
      ),
      globalCreateIcon: (
        <Tooltip content="Create" position="right">
          <CreateIcon label="Create icon" />
        </Tooltip>
      ),
      drawers: [
        <SearchDrawer
          isOpen={this.state.openDrawer === enums.search}
          key={enums.search}
          onBackHandle={this.openDrawer}
        />,
        <CreateDrawer
          isOpen={this.state.openDrawer === enums.create}
          key={enums.create}
          onBackHandle={this.openDrawer}
        />,
      ],
      onSearchDrawerOpen: () => this.openDrawer(enums.search),
      onCreateDrawerOpen: () => this.openDrawer(enums.create),
    } : {};

    return (
      <Fragment>
        <Nav
          {...props}
          containerHeaderComponent={containerHeaderComponent}
          containerTheme={presetThemes.global}
          globalPrimaryIcon={PrimaryIcon}
          globalPrimaryItemHref="/"
          globalSecondaryActions={[AccountDropdownMenu()]}
          isOpen={this.state.isOpen}
          onResize={this.onResize}
          width={this.state.width}
        >
          <AkContainerNavigationNested stack={[<Stack onToggleFeedback={this.onToggleFeedback} />]} />
          {this.state.feedback ? <FeedbackColector onClose={this.onToggleFeedback} /> : null}
        </Nav>
        {/* <WsConnect /> */}
      </Fragment>
    );
  }
}

export default Navigation;
